import script from "./ViewAppraisalPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAppraisalPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewAppraisalPage.vue?vue&type=style&index=0&id=57c7d66d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57c7d66d"]])

export default __exports__